import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { lazy } from 'react';
export var InlinePlayerLazy = /*#__PURE__*/lazy( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  var _yield$import, InlinePlayer;
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _context.next = 2;
        return import( /* webpackChunkName: "@atlaskit-internal_media-card-inlineplayer" */
        './inlinePlayer');
      case 2:
        _yield$import = _context.sent;
        InlinePlayer = _yield$import.InlinePlayer;
        return _context.abrupt("return", {
          default: InlinePlayer
        });
      case 5:
      case "end":
        return _context.stop();
    }
  }, _callee);
})));